import React from 'react';
import { AppBar, IconButton, Toolbar, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { MdArrowBack } from 'react-icons/md';
import { Fade } from "react-awesome-reveal";


interface ComponentProps {
  handleIconClick?: React.MouseEventHandler<HTMLElement>;
  title?: string;
  menuIcon?: React.ReactNode;
  handleMenuIconClick?: React.MouseEventHandler<HTMLElement>;
};

export default function EditHeader(props: ComponentProps) {
  const classes = useStyles();

  return (
    <AppBar
      position="fixed"
      className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <IconButton
          color="inherit"
          aria-label="Open drawer"
          onClick={props.handleIconClick}
          className={classes.menuButton}
        >
          <MdArrowBack />
        </IconButton>
        <div style={{ flexGrow: 1 }}>
          <Fade triggerOnce duration={2000}>
            <Typography variant="h6">
              {props.title}
            </Typography>
          </Fade>
        </div>
        {
          !props.menuIcon ? null :
            <IconButton
              onClick={props.handleMenuIconClick}
              color="inherit"
            >
              {props.menuIcon}
            </IconButton>
        }
      </Toolbar>
    </AppBar >
  );
}

const useStyles = makeStyles(theme =>
  createStyles({
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(1),
      marginLeft: -1 * theme.spacing(1) / 2,
    },
    logoText: {
      textDecoration: "none"
    },
    toolBar: {
      minHeight: 64
    },
    pushRight: {
      marginLeft: "auto"
    },
  }),
);